/**
 * Holds session keys for various sections of application
 * Use Cases: This is useful for resetting the session for a page
 */
const sessions  = {

    'tractor_owners':[

        //  admin -> tractor owners
        'tractor_owners_admin'
    ],

    'map':[


    ],

    'fbo':[

        //  admin -> fbo
        'fbo_admin'
    ],

    'operators':[

        //  admin -> operators
        'operators_admin',

        //  owner -> operators
        'operators_owner'
    ],


    'tractor_requests':[

        //  admin -> requests
        'tractor_requests'

    ],

    'tractors':[

        //  admin -> tractors
        'tractors_admin',

        //  owner -> tractors
        'tractors_owner'
    ],

    'transactions':[

        //  admin -> transactions
        'transactions_admin'
    ],

    'users':[

        //  admin -> users
        'users_admin'
    ],

    'farmers':[

        //  admin -> farmers
        'farmers_admin',

        //  fbo -> farmers
        'farmers_fbo'
    ],

    'dashboard':[

        //  dashboard states
        'admin_dashboard',
        'owner_dashboard',
        'fbo_dashboard',

        //  chart states
        'tractor_req_chart_state',
        'acreage_chart_state'
    ],

    'ussd_services':[

    ]




};

export default sessions;


// WEBPACK FOOTER //
// ./src/sessions.js